<script lang="ts">
	import EmbeddingsSelect from '$lib/EmbeddingsSelect.svelte';
	import ModelSelect from '$lib/ModelSelect.svelte';

	interface Props {
		model: string;

		embeddingsVendor: string;
	}

	let { model = $bindable(), embeddingsVendor = $bindable() }: Props = $props();
</script>

<div class="settings">
	<ModelSelect bind:model />
	<EmbeddingsSelect bind:embeddingsVendor />
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.settings {
		@include lib.flex-row();
		overflow: hidden;
		gap: 1rem;
	}
</style>
